import WeaTools from "../wea-tools";
import isEmpty from "lodash/isEmpty";
import WeaLocaleProvider from "../wea-locale-provider";
import {
  getValueWarp,
  getPageSize,
  getSelectAllMaxSize,
  getMethod
} from "./util";
const { getLabel } = WeaLocaleProvider;

export const orgInfoArr = [4, 57, 167, 168, 164, 194, 169, 170];

export function handleBrowserProps(props = {}) {
  let newProps = { ...props };
  const { type, isSingle, isMultCheckbox } = newProps;
  // 统一处理
  newProps.associativeValueWrap =
    "valueWrap" in newProps ? newProps.valueWrap : getValueWarp(newProps);
  newProps.pageSize = Number(
    newProps.pageSize > 0 ? newProps.pageSize : getPageSize(newProps)
  );
  newProps.selectedAllMaxLength = Number(
    newProps.selectedAllMaxLength > 0
      ? newProps.selectedAllMaxLength
      : getSelectAllMaxSize(newProps)
  );
  newProps.key = newProps.key || newProps.type;
  // 单选处理
  if (isSingle) {
    if (isMultCheckbox) {
      newProps.isMultCheckbox = false;
    }
    if (type == 16) {
      newProps.addSelect = true;
    }
    if ("hasAdvanceSearch" in newProps) {
      newProps.hasAdvanceSearch = newProps.hasAdvanceSearch;
    } else if ("hasAdvanceSerach" in newProps) {
      newProps.hasAdvanceSearch = newProps.hasAdvanceSerach;
    }
  }
  // 多选处理
  if (!isSingle) {
    if (type == 142) {
      newProps.hasAdvanceSearch = true;
    }
    newProps.hasAdvanceSearch = !newProps.hideAdvanceSearch;
  }
  // 单独处理
  if (type == 1 || type == 17) {
    newProps = handleHrmBrowserProps(newProps);
  }
  if (orgInfoArr.findIndex(t => t == type) !== -1) {
    newProps.isOrgInfo = true;
    newProps.dropMenuKey = "virtualCompanyid";
    newProps.handleTypes = "org";
    newProps.needGetExtraParams = true;
  }
  if (type == 165 || type == 166) {
    newProps.handleTypes = "dece_hrm";
    newProps.isLoadUser = true;
  }
  if (
    orgInfoArr.findIndex(t => t == type) !== -1 ||
    type == 165 ||
    type == 166
  ) {
    newProps._tabs = [
      {
        key: "2",
        browserProps: {
          hasAdvanceSearch: false
        }
      }
    ];
  }
  if (type == 142) {
    newProps.handleTypes = "office";
    newProps.defaultCheckStrictly = false;
    newProps.checkStrictlyKey = "checkStrictly";
  }
  if (type == "systempage") {
    newProps.defaultCheckStrictly = false;
    newProps.dropMenuKey = "key";
  }
  if (type == 152 || type == 171) {
    newProps.addSelect = true;
  }
  if (type == 161 || type == 162) {
    newProps.displaySearchAdInBar = true;
  }
  return newProps;
}

function handleHrmBrowserProps(props = {}) {
  let newProps = { ...props };
  const { type } = newProps;
  newProps.handleTypes = "hrm";
  newProps.displayType = "list";
  newProps.dropMenuKey = "virtualtype";
  newProps.showAccount = "isNoAccount";
  newProps.showCheckStrictly = false;
  newProps.hasAdvanceSearch = true;
  newProps.destUrl = "/api/public/browser/data/";
  newProps.destDataParams = newProps.dataParams || {};
  newProps.virtualUrl = `/api/public/browser/data/${type}`;
  newProps.virtualParams = { cmd: "companyvirtual" };
  newProps.needGetExtraParams = true;
  newProps.defaultCheckStrictly = false;
  newProps.searchParams = { cmd: "search" };
  newProps.searchAtTab = "";
  newProps.hideVirtualOrg = true;
  newProps.onOkClick = (values = []) => {
    if (values.length > 0) {
      const url = `/api/public/browser/data/${type}`;
      const params = {
        cmd: "addList",
        ids: values.join(",")
      };
      WeaTools.callApi(url, getMethod(url, params), params);
    }
  };
  if (isEmpty(newProps.tabs)) {
    newProps.tabs = [
      {
        name: getLabel(24515, "最近"),
        key: "1"
      },
      {
        name: getLabel(18511, "同部门"),
        key: "2"
      },
      {
        name: getLabel(15089, "我的下属"),
        key: "3"
      },
      {
        name: getLabel(18770, "按组织结构"),
        key: "4"
      },
      {
        name: getLabel(81554, "常用组"),
        key: "5"
      }
    ];
  }
  newProps._tabs = [
    {
      key: "1",
      dataParams: { cmd: "newly" },
      browserProps: {
        showAccount: false
      }
    },
    {
      key: "2",
      dataParams: { cmd: "underling" },
      browserProps: {
        hideVirtualOrg: false
      }
    },
    {
      key: "3",
      dataParams: { cmd: "branch" },
      browserProps: {
        hideVirtualOrg: false,
        showAllbranch: "alllevel"
      }
    },
    {
      key: "4",
      dataParams: { cmd: "v2resourcetree" },
      browserProps: {
        displayType: "tree",
        hideVirtualOrg: false,
        showCheckStrictly: true
      }
    },
    {
      key: "5",
      dataParams: { cmd: "v2grouptree" },
      browserProps: {
        displayType: "tree",
        isGroupTree: true,
        showCheckStrictly: true
      }
    },
    {
      key: "6",
      hideTab: true
    }
  ];
  return newProps;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/handleBrowser.js